// ============================================================
// Mocks Mesa de Operações
// Fonte: 3 relatórios internos da Indra + FA_Contraparte.xlsm (CCEE).
//   - Report Varejo 2025-04-29 -> mockPnlVarejo
//   - Relatório Trading 2025-10-31 -> mockPnlAtacado
//   - CCEE "tabela de referência cruzada" 2025-09 -> mockFaRankingCcee + mockFaMinhasContrapartes
// NOTE: dados mockados — migrar para /api/mesa/{pnl,fa} quando a integração
// Zeus/CCEE para a Mesa existir. Rastreado em #247. A aba Exposição já saiu do
// mock: consome /api/exposicao (#30, mockExposicao/MtmBadge removidos).
// ============================================================

export const mockPnlVarejo = {
  dataRef: "2025-04-29",
  book: "Brasil",
  resultado2025: { comIpca: 543453.58, semIpca: 458340.5 },
  resultado: {
    fv: { diario: 21987.56, semanal: 21987.56, mensal: 172581.44, anual: 543453.58 },
    ipcaOff: { diario: 16610.14, semanal: 16610.14, mensal: 152111.8, anual: 458340.5 },
  },
  volumeResultado: [
    { ano: 2025, volumeMwh: 1491.54, volumeMwm: 0.17, resultadoIpcaOn: 35712.21, resultadoIpcaOff: 35712.21 },
    { ano: 2026, volumeMwh: 3269.4, volumeMwm: 0.37, resultadoIpcaOn: 78279.77, resultadoIpcaOff: 55518.75 },
    { ano: 2027, volumeMwh: 4739.04, volumeMwm: 0.54, resultadoIpcaOn: 113467.6, resultadoIpcaOff: 94057.44 },
    { ano: 2028, volumeMwh: 4499.47, volumeMwm: 0.51, resultadoIpcaOn: 107731.59, resultadoIpcaOff: 87726.11 },
    { ano: 2029, volumeMwh: 4244.28, volumeMwm: 0.48, resultadoIpcaOn: 101621.48, resultadoIpcaOff: 88147.78 },
    { ano: 2030, volumeMwh: 2718.72, volumeMwm: 0.31, resultadoIpcaOn: 65094.75, resultadoIpcaOff: 48142.68 },
    { ano: 2031, volumeMwh: 1735.2, volumeMwm: 0.2, resultadoIpcaOn: 41546.17, resultadoIpcaOff: 40269.43 },
    { ano: 2032, volumeMwh: 0, volumeMwm: 0, resultadoIpcaOn: 0, resultadoIpcaOff: 0 },
    { ano: 2033, volumeMwh: 0, volumeMwm: 0, resultadoIpcaOn: 0, resultadoIpcaOff: 0 },
    { ano: 2034, volumeMwh: 0, volumeMwm: 0, resultadoIpcaOn: 0, resultadoIpcaOff: 0 },
    { ano: 2035, volumeMwh: 0, volumeMwm: 0, resultadoIpcaOn: 0, resultadoIpcaOff: 0 },
  ],
  total: { volumeMwh: 22697.65, volumeMwm: 2.59, resultadoIpcaOn: 543453.58, resultadoIpcaOff: 449574.4 },
  lastClients: [
    { data: "2025-04-29", cliente: "Hospital Guarnição de João Pessoa - EXÉRCITO", mtmComIpca: 21987.56, mtmSemIpca: 16610.14 },
    { data: "2025-04-25", cliente: "BRSPLICE INDUSTRIA E COMERCIO LTDA", mtmComIpca: 44329.07, mtmSemIpca: 42677.25 },
    { data: "2025-04-25", cliente: "GLASS FUTURE INDUSTRIA E COMERCIO DE VIDROS LTDA", mtmComIpca: 57065.41, mtmSemIpca: 53420.88 },
    { data: "2025-04-11", cliente: "RP SOPRO INDUSTRIAL E COMÉRCIO LTDA", mtmComIpca: 49199.4, mtmSemIpca: 39403.53 },
    { data: "2025-03-25", cliente: "COMUNIDADE EVANGELICA INTEGRADA DA AMAZONIA", mtmComIpca: 79000.64, mtmSemIpca: 71378.02 },
  ],
};

export const mockPnlAtacado = {
  dataRef: "2025-10-31",
  book: "Brasil",
  duration: 3.94,
  posicaoCasaM1Mwm: -92.82,
  dv01Total: 37891.42,
  dv01Next: 9659.98,
  slippage: { dia: 0, mes11: -0.7, ano2025: -1.62 },
  resultado: {
    fv: { diario: -174906.09, semanal: -299070.74, mensal: 3187553.85, anual: -18379036.68 },
    pv: { diario: -169441.59, semanal: -290350.04, mensal: 2441942.41, anual: -11888680.07 },
    ipcaOff: { diario: -174906.09, semanal: -384278.86, mensal: 3681567.28, anual: -7929116.78 },
  },
  dv01PorAno: [
    { ano: 2025, dv01: 15.43, dv01Next: 112.08 },
    { ano: 2026, dv01: 375.08, dv01Next: -447.61 },
    { ano: 2027, dv01: 3586.28, dv01Next: 2016.18 },
    { ano: 2028, dv01: 7928.63, dv01Next: 3059.93 },
    { ano: 2029, dv01: 5761.17, dv01Next: 1499.52 },
    { ano: 2030, dv01: 6595.08, dv01Next: 1356.78 },
    { ano: 2031, dv01: 7436.35, dv01Next: 1257.06 },
    { ano: 2032, dv01: 2286.92, dv01Next: 332.71 },
    { ano: 2033, dv01: 2162.87, dv01Next: 276.72 },
    { ano: 2034, dv01: 1678.44, dv01Next: 190.04 },
    { ano: 2035, dv01: 65.15, dv01Next: 6.58 },
  ],
  curvaCurta: [
    { vertice: "out-25", precoD0: 249.0, precoD1: 249.0, delta: 0.0, mwm: -23.68, mwh: -17618 },
    { vertice: "nov-25", precoD0: 297.0, precoD1: 290.0, delta: 7.0, mwm: -21.06, mwh: -15166 },
    { vertice: "dez-25", precoD0: 240.0, precoD1: 232.0, delta: 8.0, mwm: 15.4, mwh: 11461 },
    { vertice: "jan-26", precoD0: 240.0, precoD1: 232.0, delta: 8.0, mwm: -4.65, mwh: -3460 },
    { vertice: "fev-26", precoD0: 240.0, precoD1: 232.0, delta: 8.0, mwm: -5.5, mwh: -4089 },
    { vertice: "mar-26", precoD0: 240.0, precoD1: 232.0, delta: 8.0, mwm: -4.8, mwh: -3224 },
  ],
  curvaLonga: [
    { vertice: "2025", precoD0: 131.0, precoD1: 128.5, delta: 2.5, mwm: 1.77, mwh: 3912, pnl: 79502.67 },
    { vertice: "2026", precoD0: 240.5, precoD1: 238.5, delta: 2.0, mwm: -0.464, mwh: -4065, pnl: 95403.42 },
    { vertice: "2027", precoD0: 205.0, precoD1: 205.0, delta: 0.0, mwm: -9.32, mwh: -81655, pnl: 0 },
    { vertice: "2028", precoD0: 190.4, precoD1: 190.4, delta: 0.0, mwm: -18.1, mwh: -158969, pnl: 0 },
    { vertice: "2029", precoD0: 165.0, precoD1: 165.0, delta: 0.0, mwm: -7.18, mwh: -62897, pnl: 0 },
    { vertice: "2030", precoD0: 155.7, precoD1: 155.7, delta: 0.0, mwm: -6.66, mwh: -58370, pnl: 0 },
    { vertice: "2031", precoD0: 149.0, precoD1: 149.0, delta: 0.0, mwm: -6.0, mwh: -52532, pnl: 0 },
    { vertice: "2032", precoD0: 143.5, precoD1: 143.5, delta: 0.0, mwm: -1.17, mwh: -10288, pnl: 0 },
    { vertice: "2033", precoD0: 141.5, precoD1: 141.5, delta: 0.0, mwm: -0.94, mwh: -8253, pnl: 0 },
    { vertice: "2034", precoD0: 140.0, precoD1: 140.0, delta: 0.0, mwm: -0.66, mwh: -5753, pnl: 0 },
    { vertice: "2035", precoD0: 140.0, precoD1: 140.0, delta: 0.0, mwm: -0.09, mwh: -759, pnl: 0 },
  ],
  totalMwh: -471723,
  totalPnl: 174906.09,
};

export const mockFaRankingCcee = [
  { sigla: "GLASSMAXI", classe: "Consumidor Especial", codEvento: 202508000, fa: 35885.78 },
  { sigla: "EMBAQUIM CL", classe: "Consumidor Livre", codEvento: 202508000, fa: 35033.26 },
  { sigla: "EMBAQUIM CL", classe: "Consumidor Livre", codEvento: 202509000, fa: 28845.6 },
  { sigla: "EMBAQUIM CL", classe: "Consumidor Livre", codEvento: 202507000, fa: 21475.85 },
  { sigla: "GLASSMAXI", classe: "Consumidor Especial", codEvento: 202507000, fa: 14284.42 },
  { sigla: "GLASSMAXI", classe: "Consumidor Especial", codEvento: 202509000, fa: 14038.93 },
  { sigla: "PAPELIAL", classe: "Consumidor Especial", codEvento: 202507000, fa: 4541.93 },
  { sigla: "ARVEDI", classe: "Consumidor Especial", codEvento: 202508000, fa: 2168.99 },
  { sigla: "SULINA", classe: "Consumidor Especial", codEvento: 202508000, fa: 1767.79 },
  { sigla: "SULINA", classe: "Consumidor Especial", codEvento: 202507000, fa: 1454.6 },
  { sigla: "ARVEDI", classe: "Consumidor Especial", codEvento: 202507000, fa: 1422.74 },
  { sigla: "SULINA", classe: "Consumidor Especial", codEvento: 202509000, fa: 1336.05 },
  { sigla: "ARVEDI", classe: "Consumidor Especial", codEvento: 202509000, fa: 1165.67 },
  { sigla: "ES PLASTICOS", classe: "Consumidor Especial", codEvento: 202508000, fa: 745.56 },
  { sigla: "CAVERNOSO II", classe: "Produtor Independente", codEvento: 202507002, fa: 732.32 },
  { sigla: "CAVERNOSO II", classe: "Produtor Independente", codEvento: 202507001, fa: 711.29 },
  { sigla: "EOL SERRA DO ASSURUA 4 APE", classe: "Produtor Independente", codEvento: 202509001, fa: 697.6 },
  { sigla: "ES PLASTICOS", classe: "Consumidor Especial", codEvento: 202509000, fa: 674.39 },
  { sigla: "EOL SERRA DO ASSURUA 4 APE", classe: "Produtor Independente", codEvento: 202509002, fa: 610.06 },
  { sigla: "SHOPPING LIMEIRA", classe: "Consumidor Especial", codEvento: 202507000, fa: 602.01 },
  { sigla: "VITAPELLI", classe: "Consumidor Livre", codEvento: 202507000, fa: 545.14 },
  { sigla: "ES PLASTICOS", classe: "Consumidor Especial", codEvento: 202507000, fa: 542.19 },
  { sigla: "VITAPELLI", classe: "Consumidor Livre", codEvento: 202509000, fa: 541.88 },
  { sigla: "VITAPELLI", classe: "Consumidor Livre", codEvento: 202508000, fa: 531.74 },
  { sigla: "SHOPPING LIMEIRA", classe: "Consumidor Especial", codEvento: 202509000, fa: 511.18 },
  { sigla: "SHOPPING LIMEIRA", classe: "Consumidor Especial", codEvento: 202508000, fa: 485.63 },
  { sigla: "EOL SERRA DO ASSURUA 4 APE", classe: "Produtor Independente", codEvento: 202508005, fa: 412.92 },
  { sigla: "TERA PAPEIS", classe: "Consumidor Especial", codEvento: 202507000, fa: 395.23 },
  { sigla: "EOL SERRA DO ASSURUA 4 APE", classe: "Produtor Independente", codEvento: 202508004, fa: 367.32 },
  { sigla: "SHOP CONTINENTE", classe: "Consumidor Especial", codEvento: 202509000, fa: 357.09 },
];

export const mockFaMinhasContrapartes = [
  { sigla: "TEN ENERGY", faHist: [1.6552, 1.6552, 1.3739, 1.3749] },
  { sigla: "OT ENERGIA", faHist: [1.3934, 1.7097, 1.3949, 1.2675] },
  { sigla: "ELERAGESTAO", faHist: [1.2408, 1.4511, 0.503, 0.5697] },
  { sigla: "GERAMAMORE", faHist: [1.0432, 1.0867, 1.3652, 1.4988] },
  { sigla: "SOLAR BR COM", faHist: [1.0349, 1.0078, 0.9099, 0.843] },
  { sigla: "ENEL TRADING", faHist: [0.9255, 0.9342, 0.646, 0.6644] },
  { sigla: "AMERICA", faHist: [0.8877, 0.8865, 0.895, 0.8732] },
  { sigla: "ZETA ENERGIA", faHist: [0.6824, 0.6738, 0.6203, 0.5894] },
  { sigla: "FORTE COM", faHist: [0.5973, 0.6228, 0.6261, 0.5739] },
  { sigla: "BID", faHist: [0.5708, 0.5355, 0.7991, 0.7757] },
  { sigla: "MEGA WATT", faHist: [0.4607, 0.5111, 0.3645, 0.599] },
  { sigla: "ATIAIA", faHist: [0.4335, 0.4453, 0.3161, 0.3219] },
  { sigla: "ENGIE BR COM", faHist: [0.4122, 0, 0, 0] },
  { sigla: "ELECTRA ENERGY", faHist: [0.3995, 0.3987, 0.3349, 0.2689] },
  { sigla: "TRINITY ENERGIA", faHist: [0.3879, 0.3939, 0.4744, 0.4272] },
  { sigla: "ENERGISA COM", faHist: [0.3658, 0.3784, 0.4438, 0.3646] },
  { sigla: "OLYMPE", faHist: [0.3576, 0.3585, 0.3587, 0.3426] },
  { sigla: "QUANTACOM", faHist: [0.3211, 0.3194, 0.1719, 0.1652] },
  { sigla: "00_VPCOM", faHist: [0.2762, 0.2754, 0.2488, 0.2442] },
  { sigla: "BTG PACTUAL ENERGIA", faHist: [0.2019, 0.1961, 0.1409, 0.1277] },
];

export const mockFaSemanas = ["2025-09-25", "2025-09-18", "2025-09-11", "2025-09-04"];

// faCor SAIU daqui (fail-closed 02/08): é regra de negócio real, não mock —
// vive em utils/faCor.ts. Este arquivo agora só tem DADO de demonstração e só
// pode ser importado pelos componentes-demo rotulados (guard em
// mockImportGuard.test.ts).
